import { createPortal } from 'react-dom'

export default function ConfirmModal({ title, message, confirmLabel, cancelLabel, onConfirm, onCancel }) {
  return createPortal((
    <div
      // zIndex 12000 — выше окна «оплата в обработке» (11000) и модалки (10000).
      style={{ position: 'fixed', inset: 0, zIndex: 12000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 24px' }}
      onClick={onCancel}
    >
      {/* Backdrop. Без backdrop-filter: на iOS Safari размытие на position:fixed
          ломает порядок слоёв; сплошной фон надёжнее закрывает всё позади. */}
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.92)' }} />

      {/* Dialog */}
      <div
        onClick={e => e.stopPropagation()}
        style={{
          position: 'relative', zIndex: 1,
          background: '#1C1C1E',
          borderRadius: 24,
          width: '100%',
          maxWidth: 340,
          boxShadow: '0 32px 80px rgba(0,0,0,0.8)',
          border: '1px solid rgba(255,59,48,0.15)',
          overflow: 'hidden',
        }}
      >
        {/* Red accent top bar */}
        <div style={{ height: 3, background: 'linear-gradient(90deg, #FF3B30, #34D399)' }} />

        <div style={{ padding: '24px 22px 22px' }}>
          {/* Icon row */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
            <div style={{
              width: 48, height: 48, borderRadius: 14, flexShrink: 0,
              background: 'rgba(255,59,48,0.12)',
              border: '1px solid rgba(255,59,48,0.25)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 20,
            }}>
              🗑️
            </div>
            <p style={{ fontSize: 17, fontWeight: 700, color: '#FFFFFF', margin: 0, lineHeight: 1.3 }}>{title}</p>
          </div>

          {/* Message */}
          {message && (
            <div style={{
              background: 'rgba(255,59,48,0.07)',
              border: '1px solid rgba(255,59,48,0.15)',
              borderRadius: 12,
              padding: '11px 14px',
              marginBottom: 20,
            }}>
              <p style={{ fontSize: 13, color: '#C0C0C0', margin: 0, lineHeight: 1.6 }}>{message}</p>
            </div>
          )}

          {/* Buttons */}
          <div style={{ display: 'flex', gap: 10 }}>
            <button
              onClick={onCancel}
              style={{
                flex: 1, padding: '13px', borderRadius: 13,
                fontSize: 14, fontWeight: 600,
                background: 'rgba(255,255,255,0.07)', color: '#8E8E93',
                border: '1px solid rgba(255,255,255,0.08)', cursor: 'pointer',
              }}
            >
              {cancelLabel}
            </button>
            <button
              onClick={onConfirm}
              style={{
                flex: 1, padding: '13px', borderRadius: 13,
                fontSize: 14, fontWeight: 700,
                background: 'linear-gradient(135deg, #FF3B30 0%, #C0392B 100%)',
                color: '#fff',
                border: 'none', cursor: 'pointer',
                boxShadow: '0 4px 16px rgba(255,59,48,0.3)',
              }}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  ), document.body)
}
